import { Stack } from '@/components/layout';
import { Text } from '@/components/ui/text';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';

type WelcomeBannerProps = {
  userFirstName?: string;
  now?: Date;
};

function truncateWithEllipsis(text: string, maxChars: number) {
  const t = text.trim();
  if (t.length <= maxChars) return t;
  return t.slice(0, maxChars) + '…';
}

function getGreetingLabel(date: Date) {
  const hour = date.getHours();
  if (hour < 12) {
    return STRINGS.home.greeting.morning;
  }
  if (hour < 17) {
    return STRINGS.home.greeting.afternoon;
  }
  return STRINGS.home.greeting.evening;
}

export function WelcomeBanner({ userFirstName = '', now = new Date() }: WelcomeBannerProps) {
  const greetingBase = getGreetingLabel(now);
  const { scale, isTablet } = useScaling();

  const greeting = `${greetingBase}, ${truncateWithEllipsis(userFirstName, isTablet ? 30 : 15)}.`;
  const styles = useStyles();

  return (
    <Stack
      width="100%"
      direction="row"
      align="stretch"
      maxWidth={scale({ phone: 339, tablet: 400 })}
      style={styles.wrapper}>
      <Stack
        width={scale(9)}
        backgroundColor={colors.Blue}
        borderTopLeftRadius={2}
        borderBottomLeftRadius={2}
      />
      <Stack
        flex={1}
        paddingX={scale(21)}
        paddingY={scale({ phone: 23, tablet: 20 })}
        backgroundColor="white"
        borderTopRightRadius={scale(2)}
        borderBottomRightRadius={scale(2)}>
        <Text
          variant={
            isTablet
              ? 'Font Inter/Subtitle/Bold 14px'
              : 'Font Montserrat/Subtitle/Minimize 1 Bold 11px'
          }
          fontWeight={isTablet ? undefined : '800'}
          style={[styles.greetingText, styles.uppercase]}>
          {greeting}
        </Text>
      </Stack>
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  wrapper: {
    marginTop: scale({ phone: 12, tablet: 80 }),
    marginBottom: scale(16),
  },
  greetingText: {
    color: colors.Blue,
  },
  uppercase: {
    textTransform: 'uppercase',
  },
}));
